import {
  MEMBERFORM_FETCHITEM_LOAD,
  MEMBERFORM_FETCHITEM_SUCCEED,
  MEMBERFORM_FETCHITEM_FAIL,
  MEMBERFORM_EDITFORM_CHANGE,
  MEMBERFORM_ENTER_RESET,
  MEMBERFORM_CREATEITEM_LOAD,
  MEMBERFORM_CREATEITEM_SUCCEED,
  MEMBERFORM_CREATEITEM_FAIL,
  MEMBERFORM_EDITITEM_LOAD,
  MEMBERFORM_EDITITEM_SUCCEED,
  MEMBERFORM_EDITITEM_FAIL,
  MEMBERFORM_DELETEITEM_LOAD,
  MEMBERFORM_DELETEITEM_SUCCEED,
  MEMBERFORM_DELETEITEM_FAIL,
  MEMBERFORM_CVJOB_START,
  MEMBERFORM_CVJOB_PROGRESS,
  MEMBERFORM_CVJOB_COMPLETE,
  MEMBERFORM_CVJOB_DISMISS,
  MEMBERFORM_CVJOB_STATUS,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case MEMBERFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case MEMBERFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case MEMBERFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case MEMBERFORM_ENTER_RESET:
      return {}
    case MEMBERFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case MEMBERFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case MEMBERFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case MEMBERFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case MEMBERFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case MEMBERFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case MEMBERFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case MEMBERFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case MEMBERFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case MEMBERFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    case MEMBERFORM_CVJOB_START:
      return {
        ...state,
        cvJobId: action.cvJobId,
        cvJobTotal: action.cvJobTotal,
        cvJobProgress: null,
        cvJobComplete: false,
      }
    case MEMBERFORM_CVJOB_PROGRESS:
      return { ...state, cvJobProgress: action.progress }
    case MEMBERFORM_CVJOB_COMPLETE:
      return { ...state, cvJobProgress: action.progress, cvJobComplete: true }
    case MEMBERFORM_CVJOB_DISMISS:
      return {
        ...state,
        cvJobId: null,
        cvJobTotal: null,
        cvJobProgress: null,
        cvJobComplete: false,
        cvJobStatus: null,
        cvJobMessage: null,
      }
    case MEMBERFORM_CVJOB_STATUS:
      return {
        ...state,
        cvJobStatus: action.cvJobStatus,
        cvJobMessage: action.cvJobMessage,
      }
    default:
      return state
  }
}
